// src/routes/DashboardRoutes.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminDashboard from "../pages/AdminDashboard";
import Category from "../pages/category-module/Category";
import authService from "../services/authService";
import SubCategory from "../pages/category-module/SubCategory";
import ReadProducts from "../pages/product-module/ReadProducts";
import CreateProduct from "../pages/product-module/CreateProduct";
import SellerReadProducts from "../pages/product-module/SellerReadProducts";
import SellerPendingReadProducts from "../pages/product-module/SellerPendingReadProducts";
import UpdateProduct from "../pages/product-module/UpdateProduct";
import CreateBanner from "../pages/home-page-module/banner/CreateBanner";
import ReadBanners from "../pages/home-page-module/banner/ReadBanners";
import UpdateBanner from "../pages/home-page-module/banner/UpdateBanner";
import ImageGallery from "../pages/product-module/image-gallery/ImageGallery";
import AllOrders from "../pages/order-module/AllOrders";
import AllCanceledOrders from "../pages/order-module/AllCanceledOrders";
import AllDeliveredOrders from "../pages/order-module/AllDeliveredOrders";
import AllNewPendingOrders from "../pages/order-module/AllNewPendingOrders";
import AllPendingOrders from "../pages/order-module/AllPendingOrders";
import ReadAllTransaction from "../pages/order-module/transaction-manage/ReadAllTransaction";
import ReadCustomers from "../pages/user-manage-module/ReadCustomers";
import ContactUsMessages from "../pages/contact-us-module/ContactUsMessages";
import ReadSoldProducts from "../pages/product-module/ReadSoldProducts";
import ReadOfferesProducts from "../pages/product-module/ReadOfferesProducts";
import CreateCustomer from "../pages/user-manage-module/CreateCustomer";
import DisplayParticularOrderDetails from "../pages/order-module/DisplayParticularOrderDetails";
import CashOnDeliveryPayment from "../pages/payment-methods-module/CashOnDeliveryPayment";
import PaypalPayment from "../pages/payment-methods-module/PaypalPayment";
import PayUPayment from "../pages/payment-methods-module/PayUPayment";
import ChangePassword from "../pages/profile-and-change-password/ChangePassword";
import ReadAndUpdateProfile from "../pages/profile-and-change-password/ReadAndUpdateProfile";
import ReadProductReviews from "../pages/product-module/product-reviews/ReadProductReviews";
import ShippingRule from "../pages/shipping-module/ShippingRule";
import AdminLogin from "../auth/AdminLogin";
import CreateBulkProducts from "../pages/product-module/CreateBulkProduct";
import ChildCategory from "../pages/category-module/ChildCategory";
import HomeSectionProducts from "../pages/Home-pagesetting-module/Homesectionproduct";

import HomeSectionCreate from "../pages/Home-pagesetting-module/Createhomesection";
import EditHomeSection from "../pages/Home-pagesetting-module/Edithomesection";
import Brand from "../pages/Brand-module/Brand";


const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const user = authService.getCurrentUser();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles.includes(user.user_role)) {
    return children;
  }
  return <Navigate to="/unauthorized" replace />;
};

const DashboardRoutes = () => {
  return (
    <Routes>

      <Route
        path="/login"
        element={
          <AdminLogin />
        }
      />


      <Route
        path="/dashboard"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AdminDashboard />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/slider/create"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <CreateBanner />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/sliders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadBanners />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/slider/edit/:id"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <UpdateBanner />
          </RoleProtectedRoute>
        }
      /> 
         <Route
        path="/brands"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
          <Brand/>
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/home-section-products"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <HomeSectionProducts />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/create-home-section"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <HomeSectionCreate />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/edit-home-section/:id"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <EditHomeSection />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/categories"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <Category />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/sub-categories"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <SubCategory />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/child-categories"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ChildCategory />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/all-products" 
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadProducts />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/product/create"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <CreateProduct />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/active-products"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <SellerReadProducts />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/inactive-products"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <SellerPendingReadProducts />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/all-sold-products"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadSoldProducts />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/all-offers-products"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadOfferesProducts />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/products/edit/:id/"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <UpdateProduct />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/product-image-gallery/:id/"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ImageGallery />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/product-review/:productId"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadProductReviews />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/all-orders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AllOrders />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/new-orders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AllNewPendingOrders />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/delivered-orders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AllDeliveredOrders />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/cancelled-orders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AllCanceledOrders />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/pending-orders"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <AllPendingOrders />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/order/:id"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <DisplayParticularOrderDetails />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/cod-settings"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <CashOnDeliveryPayment />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/paypal-settings"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <PaypalPayment />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/payu-settings"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <PayUPayment />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/transactions"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadAllTransaction />
          </RoleProtectedRoute>
        }
      />



      <Route
        path="/customer-management"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadCustomers />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/contact-us-list"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ContactUsMessages />
          </RoleProtectedRoute>
        }
      />


      <Route
        path="/customer/create"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <CreateCustomer />
          </RoleProtectedRoute>
        }
      />


      <Route
        path="/shipping-rule"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ShippingRule />
          </RoleProtectedRoute>
        }
      />


      <Route
        path="/change-password"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ChangePassword />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <ReadAndUpdateProfile />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="/product/create-bulk"
        element={
          <RoleProtectedRoute allowedRoles={["admin"]}>
            <CreateBulkProducts />
          </RoleProtectedRoute>
        }
      />


    </Routes>
  );
};

export default DashboardRoutes;

